// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"130":"4afafdf3","296":"ea88be26"}[chunkId] || chunkId) + "." + {"130":"257b163d3883e3a0","296":"1a112e62a60bad04","322":"c08f41e3ad123c69"}[chunkId] + ".js";
};